<template>
  <div class="makina-form">
    <el-form v-loading="loading" ref="makinaForm" :model="form" :rules="rules" label-position="top-left">
      <el-form-item prop="adi" label="Koku Makinası Adi">
        <el-input v-model="form.adi" maxlength="255" minlength="1" type="text"></el-input>
      </el-form-item>
      <el-form-item prop="buyukluk" label="Koku Makinası Büyüklük">
        <el-input v-model="form.buyukluk" maxlength="15" minlength="1" type="text"></el-input>
      </el-form-item>
      <el-form-item prop="renk" label="Koku Makinası Renk">
        <el-input v-model="form.renk" maxlength="15" minlength="1" type="text"></el-input>
      </el-form-item>
      <el-form-item prop="code" label="Kod">
        <el-input v-model="form.code" maxlength="15" minlength="1" type="text"></el-input>
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="center">
      <el-button type="primary" @click="submit">Kaydet</el-button>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: 'makina-form',
    props: {
      visible:  { type: Boolean },
      makina:  { type: Object, default: null },
    },
    data() {
      return {
        loading: false,
        form: {
          adi: null,
          buyukluk: null,
          renk: null,
          code: null,
        },
        rules: {
          adi: [ { required: true, message: 'Adi gerekli', trigger: 'change' } ],
          buyukluk: [ { required: true, message: 'Büyüklük gerekli', trigger: 'change' } ],
          renk: [ { required: true, message: 'Renk gerekli', trigger: 'change' } ],
          code: [ { required: true, message: 'Kod gerekli', trigger: 'change' } ],
        }
      };
    },
    methods: {
      submit() {
        this.$refs.makinaForm.validate((valid) => {
          if (valid) {
            if (!this.makina) {
              this.create();
            } else {
              this.update();
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      create() {
        this.loading = true;
        this.$requests.Makina.createMakina(this.form)
                .then(() => {
                  this.$refs.makinaForm.resetFields();
                  this.$emit('success');
                })
                .catch((e) => {
                  console.error('error', e);
                })
                .then(() => {
                  this.loading = false;
                });
      },
      update() {
        let makina = Object.assign({},  this.form);
        delete makina.id;
        this.loading = true;
        this.$requests.Makina.updateMakina(this.form.id, makina)
                .then(() => {
                  this.$refs.makinaForm.resetFields();
                  this.$emit('success');
                })
                .catch((e) => {
                  console.error('error', e);
                })
                .then(() => {
                  this.loading = false;
                });
      },
    },
    mounted() {
      if (this.visible && this.makina) {
        this.form = Object.assign({}, this.makina);
      }
    },
    watch: {
      visible() {
        if (this.visible && this.makina) {
          this.form = Object.assign({}, this.makina);
        }
      },
    },
  }
</script>
